export const FACES_FIELD_DEFINITION_DOTTED_KEY = 'Ai.Faces';
export const PERSON_ID_DEFINITION_DOTTED_KEY = 'Ai.Faces.Face.Person.RecordId';
export const HAS_FACES_FIELD_DEFINITION_DOTTED_KEY = 'Ai.HasFaces';
export const AI_STATUS_FIELD_DEFINITION_DOTTED_KEY = 'Ai.AiStatus';
